import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import type { CarePlanResponse } from "@/core/types";

import { getCarePlan } from "../queryFunctions/getCarePlan";
import { memberCarePlanKeys } from "../keyFactory";

type UseCarePlanProps<TData = CarePlanResponse> = {
  patientId: string;
  select?: (data: CarePlanResponse) => TData;
};

type CarePlanQueryOptions = UseQueryOptions<
  CarePlanResponse,
  unknown,
  CarePlanResponse,
  ReturnType<typeof memberCarePlanKeys.detail>
>;

function optionFactory(patientId: string) {
  return {
    queryFn: () => getCarePlan(patientId),
    queryKey: memberCarePlanKeys.detail(patientId),
  } satisfies CarePlanQueryOptions;
}

export function useCarePlan<TData = CarePlanResponse>({
  patientId,
  select,
}: UseCarePlanProps<TData>) {
  return useQuery({ ...optionFactory(patientId), select });
}
